import useTranslation from "next-translate/useTranslation";
import React from "react";
import PrixDeBien from "./PrixDeBien/PrixDeBien";
import RevenuMensuel from "./RevenuMensuelComponent/RevenuMensuel";
import style from "./style.module.css";

function CalculezBudget() {
  const { t } = useTranslation("creditImmo");

  return (
    <div className={style.container}>
      <RevenuMensuel t={t} />
      <PrixDeBien t={t} />
    </div>
  );
}

export default CalculezBudget;
